import './Dokumenty.css';
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { BlocksRenderer } from "@strapi/blocks-react-renderer";
// import ReactMarkdown from "react-markdown";
import { useTranslation } from "react-i18next";
import CarouselWithMap from "./Components_2/CarouselWithMap";
import SidebarMenu from "./Components_2/sideBarMenu";

function DokumentyDetail() {
    const [t, i18n] = useTranslation("global");
    let { id } = useParams();
    const [dokumentyDetail, setDokumentyDetail] = useState({ attributes: { name: '', description: '', files: { data: [] } } });
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    // Initial fetch
    useEffect(() => {
        fetch(process.env.REACT_APP_API_URL + `/api/kpbi-dokumenties/${id}?populate=*`)
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then(data => {
                setDokumentyDetail(data.data);
                setLoading(false);
            })
            .catch(error => {
                setError(error);
                setLoading(false);
            });
    }, [id]);

    const findLocalization = (data, language) => {
        let localization = {};

        if (data.attributes.locale !== language) {
            const foundLocalization = data.attributes.localizations?.data.find(loc => loc.attributes.locale === language);

            if (foundLocalization) {
                localization.name = foundLocalization.attributes.name;
                localization.description = foundLocalization.attributes.description;
            } else {
                localization.name = data.attributes.name;
                localization.description = data.attributes.description;
            }
        } else {
            localization.name = data.attributes.name;
            localization.description = data.attributes.description;
        }

        return localization;
    };
    if (loading) return <div>Načítání...</div>;
    if (error) return <div>Chyba: {error.message}</div>;

    const content = findLocalization(dokumentyDetail, i18n.language);

    return (
        <div>
            <div className="carousel_ostatni">
                <CarouselWithMap />
            </div>
            <div className="row">
                <div className="col-lg-9">
                    <div className='details-container'>
                        <h1 className="details-title">{content.name}</h1>
                        <div className="details-description">
                            {/* <ReactMarkdown key={dokumentyDetail.id}>
                                {content.description}
                            </ReactMarkdown> */}
                            <BlocksRenderer
                                content={
                                Array.isArray(content?.description) ? content.description : []
                                }
                            ></BlocksRenderer>
                        </div>
                        {dokumentyDetail.attributes?.files?.data?.length > 0 && (
                            <div className="details-files">
                                <h2>{t("soubory")}</h2>
                                {dokumentyDetail.attributes.files.data.map((file) => (
                                    <div key={file.id} className='file-link'>
                                        <a href={`${process.env.REACT_APP_API_URL}${file.attributes.url}`}>
                                            {file.attributes.name}
                                        </a>
                                    </div>
                                ))}
                            </div>
                        )}
                        <button className='btn btn-primary btn-back btn_vice' onClick={() => navigate(-1)}>
                            {t("zpet")}
                        </button>
                    </div>
                </div>
                <SidebarMenu />
            </div>
        </div>
    );
}

export default DokumentyDetail;
